import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/free-regular-svg-icons";
import { useDispatch } from "react-redux";

const Folder = (props) => {
  const dispatch = useDispatch();
  const setDestinationFolderId = (event) => {
    dispatch({
      type: "SET_FOLDER_ID_FOR_COPY",
      payload: event.target.value,
    });
  };
  return (
    <div className="copy-file-folder-list">
      <div>
        <input
          className="form-check-input"
          type="radio"
          onChange={(e) => setDestinationFolderId(e)}
          value={props?.id}
          name="folders"
          id={props?.id}
        />
        
        <label className="form-check-label not-select-text" htmlFor={props?.id}>
          <FontAwesomeIcon className="file-icon" icon={faFolderOpen} size="lg" />{props?.name}
        </label>
      </div>
      {props?.folders?.map((folder) => (
        <Folder
          id={folder.id}
          name={folder.name}
          key={folder.id}
          folders={folder?.folders}
        />
      ))}
    </div>
  );
};

export default Folder;
